import { TFlightLog } from "../../../../@types";

export function readUpdatedFlight(response: unknown, id: number): TFlightLog {
	const flight = (response as { flight?: TFlightLog } | null)?.flight;
	if (
		!id ||
		!flight ||
		flight.id !== id ||
		typeof flight.description !== "string" ||
		typeof flight.landing !== "string"
	) {
		throw new Error("Invalid flight update response");
	}
	return flight;
}

export function mergeUpdatedFlight(
	current: TFlightLog | null,
	updated: TFlightLog,
): TFlightLog | null {
	return current?.id === updated.id ? { ...current, ...updated } : current;
}
